import { render, staticRenderFns } from "./avatar-list.vue?vue&type=template&id=bda401e2&scoped=true&"
import script from "./avatar-list.vue?vue&type=script&lang=ts&"
export * from "./avatar-list.vue?vue&type=script&lang=ts&"
import style0 from "./avatar-list.vue?vue&type=style&index=0&id=bda401e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda401e2",
  null
  
)

export default component.exports